const SUPPORTED_CAMERA_LOCALE_CODES = [
  'ar_SA',
  'cs_CZ',
  'de_DE',
  'en_US',
  'es_ES',
  'fi_FI',
  'fr_FR',
  'id_ID',
  'ko_KR',
  'nl_NL',
  'pt_PT',
  'sk_SK',
  'vi_VN',
  'zh_CN',
  'zh_HK',
];

export type SupportedCameraLocaleCode =
  (typeof SUPPORTED_CAMERA_LOCALE_CODES)[number];

export const isSupportedCameraLocaleCode = (
  value: string,
): value is SupportedCameraLocaleCode =>
  (SUPPORTED_CAMERA_LOCALE_CODES as readonly string[]).includes(value);
